const metaConfig = {
  "/": {
    title: "JIVI Enterprise Workforce Management System for Terminals",
    description:
      "Jivi Solutions is a global leader in workforce management software, empowering businesses with intelligent scheduling, automated work allocation, and real-time resource optimization.",
  },

  "/about": {
    title: "About JIVIEWS Solutions | Global Leader in Workforce Management Software",
    description:
      "Learn about Jivi Solutions, our mission, vision, and enterprise workforce management expertise.",
  },

  "/schedule-a-demo": {
    title: "Schedule a Demo | Explore JIVIEWS Solutions for Workforce & HR Automation",
    description:
      "schedule a demo, JIVIEWS demo, workforce management software, HR automation demo, business productivity tools, employee self service demo, time and attendance demo, operational efficiency solutions, JIVIEWS contact, workforce optimization demo, HR technology consultation, book demo JIVIEWS.",
  },

  "/workforce-scheduler": {
    title: "Workforce Scheduler | Intelligent Shift Planning & Employee Optimization | JIVIEWS Solutions",
    description:
      "Advanced workforce scheduling software to optimize employee productivity and shift planning.",
  },

  "/capacity-planning": {
    title: "Capacity Planning | Optimize Resources & Ensure Operational Agility | JIVIEWS Solutions",
    description:
      "JIVIEWS Capacity Planning empowers businesses to adapt quickly to last-minute operational changes. Efficiently manage vessel adjustments, resource availability, and equipment redeployment to minimize downtime and maintain productivity. Enhance decision-making, control costs, and ensure compliance with intelligent, data-driven workforce and equipment planning tools."
  },
  "/time-attendance": {
    title: "Time & Attendance Management System | Automated Workforce Tracking & Scheduling | JIVIEWS",
    description:
      "Effortlessly manage employee attendance with JIVIEWS Time & Attendance system. Automate tracking, scheduling, and reporting with real-time insights. Ensure accuracy, efficiency, and compliance in workforce management through intuitive Time Clock integration and automated exception alerts."
  },
  "/operational-workload-planning": {
    title: "Operational Workload Planning | Optimize Terminal Efficiency & Resource Allocation | JIVIEWS Solutions",
    description:
      "JIVIEWS Operational Workload Planning intelligently schedules vessels, cranes, equipment, and labor through TOS integration and real-time data. Achieve precise, time-specific, and location-based workload allocation for maximum terminal efficiency. Improve planning accuracy, reduce idle time, and enhance productivity with automated task assignment and real-time capacity monitoring."
  },
  "/automated-work-allocation-assignment": {
    title: "Automated Work Allocation & Assignment | Smart Workforce Deployment | JIVIEWS Solutions",
    description:
      "JIVIEWS Automated Work Allocation & Assignment intelligently selects and assigns manpower based on user-defined rules and operational workload planning. Empower employees with self-service tools for leave management, scheduling, and data accuracy. Improve agility, responsiveness, and efficiency through automation, ensuring optimal resource utilization and seamless workflow execution."
  },
  "/employee-self-service": {
    title: "Employee Self Service | Empower Employees & Automate HR Processes | JIVIEWS Solutions",
    description:
      "JIVIEWS Employee Self Service (ESS) empowers employees to manage schedules, leave, and personal data independently. Automate leave approvals, streamline HR workflows, and enhance transparency, efficiency, and compliance. Boost employee satisfaction, reduce administrative workload, and build a smarter, self-managed workforce."
  },

  "/connected-systems": {
    title:
      "Connected System | Seamless HR, Operations & Analytics | JIVIEWS",
    description:
      "JIVIEWS Connected System unifies workforce planning, HR, payroll, attendance, and operational data into a single intelligent platform. Enable seamless integrations, real-time insights, automated workflows, and data-driven decision-making to improve productivity, visibility, and operational efficiency across your organization."
  }

};

export default metaConfig;
